import MapView = require("../views/MapView");
import ol = require("ol");
import Portal = require("portal-gis");
import Mediator = require("../mediator");
import Base = require("./base-command");

class Handler extends Base<{}> {

    static about = `
Deprecate.

Sample handler that puts the map viewState, zoom and center on the bus.  

Usage Example:

    <EVENT 
        about="logs the maps viewstate each time the resolution changes" 
        event="map-resolution" 
        id="map-event-handler" 
        mid="app/commands/map-event-handler" />

See [get-current-extent](#app/api/get-current-extent) for getting the extent
as well as markers within that extent.
    `;

    execute(args = this.args) {
        let event = this.configuration;

        console.log("map event: ", event.id);

        this.mediator.mapViewMap(map => {

            let olView = map.getView();
            if (!olView) return;

            let viewState = olView.getState();

            // if a 'trace' event listens we can see output in console
            this.trigger({
                viewState: viewState,
                zoom: olView.getZoom(),
                center: olView.getCenter()
            })

        });

    }

}

export = Handler;  